@if (dataSource().length === 0) {
  <mohlel-empty-state />
} @else {
  <div
    echarts
    [options]="chartOptions()"
    (chartClick)="onChartClick($event)"
    class="heatmap-chart"
  ></div>
}
